import React from 'react'

function Video({ src, type = 'video/mp4', coverImage, ...others }) {
    return (
        <div>
            <video controls width="100%" poster={coverImage} {...others}>
                <source src={src} type={type} />
                Sorry, your browser doesnot support embedded videos.
            </video>
        </div>
    )
}

export default Video
